import { render, staticRenderFns } from "./BillPaymentsForm.vue?vue&type=template&id=45fca54f"
import script from "./BillPaymentsForm.vue?vue&type=script&lang=js"
export * from "./BillPaymentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports